export default __webpack_public_path__ + "static/media/presentation.ef55a115.pptx";